<template>

    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'proveedores' }">{{ $t("proveedores") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("listadoMateriaPrimaProveedor") }}
                        </li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label for="listBusiness">{{ $t("negocio") }}</label>

                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    @change="cambioNegocio()" :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.id" :label="business.establishmentName" :key="business.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">

                    <div class="row">
                        <div class="col-md-3 form-group2 justify-content-center">
                            <strong>{{ $t("proveedor") }} {{ NomProveedor }}</strong>
                        </div>
                        <div class="col-md-12  text-right" style="margin-bottom: 20px;">
                            <strong>{{ $t("filtrarPorEtiqueta") }}</strong>
                            <el-select class="select-default filterTag" size="large" v-model="filter" filterable
                                @change="cambioFiltro()" :placeholder="$t('seleccionaNegocio')">
                                <el-option v-for="filter in filterTag" class="select-primary" :value="filter.id"
                                    :label="filter.name" :key="filter.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>

                    <div v-if="listSubproducts.length > 0">
                        <div class="table-responsive">

                            <table class="table table-bordered table-striped">

                                <thead class="thead-dark">
                                    <tr>
                                        <th>{{ $t("materiaPrima") }}</th>
                                        <th>{{ $t("etiqueta") }}</th>
                                        <th>{{ $t("tipo") }}</th>
                                        <th>{{ $t("precioCompraSinIva") }}</th>
                                        <th>{{ $t("precioCompraConIva") }}</th>
                                        <th>{{ $t("Porcentaje Descuento") }}</th>
                                        <th>{{ $t("fijarprecio") }}  <i class="fas fa-info-circle" v-tooltip.top="$t('explicacionFijarPrecio')" style="cursor: pointer; margin-left: 5px;"></i></th>
                                        <th>{{ $t("acciones") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="sub in listSubproducts" :key="sub.id">
                                        <td>
                                            <div>{{ sub.name }}
                                                <span style="color: red" v-if="sub.baja == '1'">
                                                    [{{ $t("BAJA") }}]
                                                </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="sub.nombreCat">{{ sub.nombreCat }}</div>
                                            <div v-else>{{ $t("sinEtiqueta") }}</div>
                                        </td>
                                        <td>
                                            <div>{{ sub.type }}</div>
                                        </td>
                                        <td>
                                            <div>{{ parseFloat(sub.precio_compra / (1 + sub.iva / 100)).toFixed(4) }} €
                                            </div>
                                        </td>

                                        <td>
                                            <div>{{ parseFloat(sub.precio_compra).toFixed(4) }} €</div>
                                        </td>

                                        <td>
                                            <div>{{ parseFloat(sub.dto_compra).toFixed(2) }} %</div>
                                        </td>

                                        <td class="text-center">
                                            <el-switch v-model="sub.fixed_price_state" active-color="#13ce66"
                                                inactive-color="#bcbcbc" @change="guardarPrecioAcordado(sub.id)"></el-switch>
                                            
                                        </td>

                                        <td align="center">
                                            <router-link
                                                :to="{ name: 'subproducto', params: { 'idBusiness': idBusiness, 'idProveedor': idProveedor, 'NomProveedor': NomProveedor, 'filtro': filter, 'SpProv': SpProv, 'idSubproducto': sub.id, 'pag': pag } }">
                                                <button class="btn btn-danger btn-link btn-xs">
                                                    <i v-tooltip.top-center="$i18n.t('editar')"
                                                        class="fas fa-pencil-alt" style="color: orange"></i>
                                                </button>
                                            </router-link>
                                        </td>


                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div v-else class="alert alert-danger" role="alert">
                        {{ $t("noTiene") }} <strong>{{ $t("subproductosCreados") }}</strong> {{ $t("esteProveedor") }}
                    </div>

                    <div class="row" v-if="!isSearch && totalPags > 1">
                        <div class="col-md-12">
                            <nav>
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" :class="{ 'disabled': pag == 1 }">
                                        <router-link class="page-link"
                                            :to="{ name: 'subproductos', params: { pag: pag - 1 } }"
                                            v-if="pag != 1">&laquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&laquo;</span></span>
                                    </li>
                                    <li class="page-item" v-for="n in totalPags" :class="{ active: n == pag }">
                                        <router-link class="page-link"
                                            :to="{ name: 'subproductos', params: { pag: n } }">
                                            {{ n }}
                                        </router-link>
                                    </li>
                                    <li class="page-item" :class="{ 'disabled': pag == totalPags }">
                                        <router-link class="page-link"
                                            :to="{ name: 'subproductos', params: { pag: nextPag } }"
                                            v-if="pag != totalPags">
                                            &raquo;
                                        </router-link>
                                        <span v-else class="page-link"><span aria-hidden="true">&raquo;</span></span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
import { DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Checkbox } from 'element-ui'
import { Loading } from 'element-ui';
import swal from 'sweetalert2'
import { mapState } from 'vuex'
import { Switch } from 'element-ui';


export default {

    created() {
        //            this.loading = Loading.service({text: 'Cargando...'});
        this.$store.dispatch("setNameRoute", this.$i18n.t("listadoMateriaPrimaProveedor"));
        this.getBusiness();
        var filtro = this.$route.query.filtro;

        if (filtro != undefined) {
            this.filter = parseInt(filtro);
        }

        this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

    },
    components: {
        ElSwitch: Switch,
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox
    },
    data() {

        return {

            idProveedor: this.$route.params.idProveedor,
            NomProveedor: this.$route.params.NomProveedor,
            //PRUEBAS INICIO PAGINA
            loadingGeneral: null,
            peticionesIniciales: 0,
            SpProv: 1,
            loading: false,
            listBusinesses: [],
            listCategory: ["-"],
            idBusiness: this.$route.params.idBusiness,
            searchQuery: this.$route.params.query,
            isSearch: false,
            pag: this.$route.params.pag,
            totalPags: 0,
            listSubproducts: ["-"],
            filterTag: [],
            filter: -1,
            baja: 0,
            isDeBaja: false,

            inProgress: false,
            respuesta: true,
        }
    },
    watch: {
        '$route'(to, from) {
            if (to.params.pag) {
                this.pag = to.params.pag;
                this.getSubproducts();
            } else if (to.params.query) {
                this.query = to.params.query;
                this.getSubproducts();
            }
        }
    },
    computed: {
        ...mapState(["permiso"]),

        showResult() {
            if (this.listSubproducts.length == 0) {
                return this.$t('noEncontramosResultadosPara') + this.searchQuery;
            } else {
                const result = this.listSubproducts.length == 1 ? this.$t('resultado') : this.$t('resultados');
                return this.$t('mostrando') + " " + this.listSubproducts.length + " " + result;
            }
        },
        nextPag() {
            let nextPag = parseInt(this.pag) + 1;
            return nextPag;
        },
        urlExportPDF() {


            return this.$store.getters.apiUrl + "/subproducts/exportListSubproducts/PDF?idBusiness=" + this.idBusiness + "&filter=" + this.filter + "&jwt=" + this.$store.getters.jwt


        },
        urlExportExcel() {


            /*  return "../api/public/index.php/suppliers/exportGastosSupplier/Excel?idBusiness=" + this.idBusiness + "&procedencia=" + this.procedencia + "&idSupplier=" + this.idSupplier + "&datefrom=" + moment(this.datefrom).unix() + "&dateto=" + moment(this.dateto).unix() + "&jwt=" + this.$store.getters.jwt
             */
            return this.$store.getters.apiUrl + "/subproducts/exportListSubproducts/Excel?idBusiness=" + this.idBusiness + "&filter=" + this.filter + "&jwt=" + this.$store.getters.jwt
        }
    },
    updated() {

        this.peticionesIniciales++;
        if (this.peticionesIniciales === 3) {
            this.loadingGeneral.close();
        }

    },
    mounted() {
        this.getSubproducts(); 
    },

    methods: {
        
        getSubproductById(subproductId) {
            return this.listSubproducts.find(sub => sub.id === subproductId);
        },

        checkCamposPrecio(subproductId) {
            let subproduct = this.getSubproductById(subproductId);
            if (!subproduct.precio_acordado_proveedor || subproduct.precio_acordado_proveedor <= 0) {
                this.$notify({
                    message: this.$t("precioAcordadoInvalido"),
                    type: "error",
                });
                return false;
            }
            return true;
        },

        cambioNegocio() {
            this.pag = 1;
            this.totalPags = 0;
            this.filter = -1;
            this.getCategory()
            this.getSubproducts();

        },
        cambioFiltro() {


            this.pag = 1;
            this.totalPags = 0;
            this.getSubproducts();

        },

        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {

                    if (response.data.response) {

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;
                        //                        vm.loading.close();
                        vm.getSubproducts();
                        vm.getCategory();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getCategory() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'subproducts/getCategoryByBusinesses', config)
                .then(function (response) {
                    if (response.data.response) {


                        vm.filterTag = [];

                        if (response.data.result.length === 0) {

                            let category = {
                                name: vm.$t('todos'),
                                id: -1
                            };

                            vm.filterTag.push(category);

                        }

                        for (let i = 0; i < response.data.result.length; i++) {

                            if (i === 0) {

                                let category = {
                                    name: vm.$t('todos'),
                                    id: -1
                                };

                                vm.filterTag.push(category);

                            }


                            let categoryname = {
                                name: response.data.result[i].name,
                                id: response.data.result[i].id,
                            };

                            vm.filterTag.push(categoryname)

                        }

                        if (response.data.result.length > 0) {
                            vm.filterTag.push({
                                name: vm.$t('sinEtiqueta'),
                                id: 0,
                            });
                        }

                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: this.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }

                });
        },

        getSubproducts() {
            const controller = 'getSubproductsBySupplier';
            var config = {
                params: {
                    pag: this.pag,
                    idBusiness: this.idBusiness,
                    idProveedor: this.idProveedor,  // Usar idProveedor en lugar de idBusiness
                    filter: this.filter,
                    jwt: this.$store.getters.jwt,
                    baja: this.baja
                },
                headers: {
                    'Authorization': "Bearer " + this.$store.getters.jwt
                }
            };

            let vm = this;

            this.axios.get(this.$store.getters.apiUrl + "subproducts/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {

                        vm.listSubproducts = response.data.result.listSubproduct;

                        vm.listSubproducts.forEach(sub => {
                            sub.fixed_price_state = !!parseInt(sub.fixed_price_state); 
                        });

                        vm.pag = response.data.result.pag;
                        vm.totalPags = response.data.result.totalPags;
                  
                        vm.respuesta = true;

                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.respuesta = false;
                    }

                })
                .catch(function (error) {
                    console.log(error);
                });
        },



        searchSubproductos() {
            if (this.searchQuery !== undefined && this.searchQuery !== "") {
                this.$router.push({ name: 'search-subproductos', params: { query: this.searchQuery } });
                this.isSearch = true;
            }
        },
        removeSearch() {
            if (this.searchQuery && this.searchQuery !== "") {
                this.searchQuery = "";
                this.isSearch = false;
                this.$router.push({ name: 'subproductos' });
                this.getSubproducts()
            }
        },

        changeIsDeBaja() {

            if (this.isDeBaja) {
                this.baja = 1
            } else {
                this.baja = 0
            }
            this.getSubproducts()

        },
        guardarPrecioAcordado(subproductId) {
                this.inProgress = true; 

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                    },
                    headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                };

               
                var subproduct = this.getSubproductById(subproductId);  
                var fixedPriceState = subproduct.fixed_price_state ? 1 : 0;  
                
                var params = {
                    idBusiness: this.idBusiness,
                    idSubproduct: subproductId,  
                    precioAcordadoProveedor: subproduct.precio_acordado_proveedor,
                    fixed_price_state: fixedPriceState,  
                    jwt: this.$store.getters.jwt,
                };

                let vm = this;
                this.axios
                    .post(this.$store.getters.apiUrl + "subproducts/updatePrecioAcordadoProveedor", params, config)
                    .then(function (response) {
                        vm.inProgress = false;

                        if (response.data.response) {
                            vm.$notify({
                                message: vm.$t("precioAcordadoGuardadoCorrectamente"),
                                icon: "nc-icon nc-check-2",
                                timeout: 2000,
                                horizontalAlign: "right",
                                verticalAlign: "top",
                                type: "success",
                            });

                            vm.getSubproducts();
                        } else {
                            swal({
                                title: vm.$t("atencion"),
                                text: response.data.message,
                                confirmButtonClass: "btn btn-info btn-fill",
                                type: "error",
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                        vm.inProgress = false;
                    });
            
        },

    }


}

</script>

<style scoped>
tbody tr:hover {
    background-color: rgba(0, 153, 130, 0.2);
    cursor: pointer;
}

tbody td {
    padding: 0 !important;
}

td div {
    padding: 12px 8px;
    color: #333;
}

/* .form-group2{
    color: blue;
} */
.buttonsSearch:hover {
    cursor: pointer;
    background-color: rgba(0, 153, 130, 0.1);
}

.card {
    padding: 20px;
}

.input-group button {
    height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Proveedores/ListadoSubProductProveedor.vue